const expectedImageHeightWidth = {
  height: 800,
  width: 1440,
}

const expectedImageHeightWidthMobile = {
  height: 640,
  width: 360,
}

const expectedImageHeightWidthAvatar = {
  height: 140,
  width: 140,
}


/**
 *
 * @param mainFile {File}
 * @return {Promise}
*/
export function validateImageHeightAndWidth(mainFile, isAvatar= false, isMobile = false) {
  const img = new Image();
  img.src = window.URL.createObjectURL(mainFile);

  return new Promise((resolve, reject) => {
      let err = null
      img.onload = () => {
          if (!isAvatar && !isMobile && (img.naturalHeight !== expectedImageHeightWidth.height ||
              img.naturalWidth !== expectedImageHeightWidth.width)) {
            err = "Picture size must be 1440px x 800px"
          }
          if (isAvatar && (img.naturalHeight !== expectedImageHeightWidthAvatar.height ||
              img.naturalWidth !== expectedImageHeightWidthAvatar.width)) {
            err = "Picture size must be 140px x 140px"
          }
          if (isMobile && (img.naturalHeight !== expectedImageHeightWidthMobile.height ||
              img.naturalWidth !== expectedImageHeightWidthMobile.width)) {
            err = "Picture size must be 360px x 640px"
          }
          resolve({dataUrl: img.src, err: err})
      }
      img.onerror = reject
    }
  )
}
